// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".com-rank[data-v-eae57816] {\n  background-color: #fff !important;\n}\n", ""]);
// Exports
module.exports = exports;
